import axios from "axios";
import Swal from "sweetalert2";
import {
  baseUrl,
  defaultAddErrorMessage,
  defaultUpdateErrorMessage,
  errorTranslate,
  objectifyForDropdown,
} from "../util";

export const addStationaryToBusiness = ({
  businessId,
  biomass_fuel_proportion,
  fuel_comply,
  leased_fuel_proportion,
  fuel_type,
  fuel_amount,
  invoice_date,
  invoice_number,
  price_invoice,
  subcategory,
  subcategory_description,
  manuel,
  loading = null,
  setLoading = null,
  index,
  use_swal = false,
  callback = null,
  setErrorMessage = function () {
    return;
  },
  triggerInvalidate = function () {
    return;
  },
}) => {
  const key = "add-new-stationary-combustion";

  var data = JSON.stringify({
    biomass_fuel_proportion: biomass_fuel_proportion || null,
    fuel_comply: fuel_comply,
    leased_fuel_proportion: leased_fuel_proportion || null,
    fuel_type: fuel_type,
    fuel_amount: fuel_amount,
    invoice_date: invoice_date || null,
    invoice_number: invoice_number || null,
    price_invoice: price_invoice || null,
    subcategory: subcategory,
    subcategory_description: subcategory_description,
    manuel: manuel || null,
  });

  var config = {
    method: "post",
    url: baseUrl + "/api/business/" + businessId + "/stationary-combustion",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      if (use_swal) {
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      }
      if (key) {
        triggerInvalidate(key);
      }
      if (loading) setLoading("success");
      if (callback) callback();
      setErrorMessage();
    })
    .catch(function (error) {
      console.log(error);
      setErrorMessage(error.response.data);
      if (loading) setLoading("failed");
      if (use_swal) {
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: defaultAddErrorMessage,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      }
    });
};

export const deleteStationary = ({
  businessId,
  objectId,
  use_swal = false,
  loading = null,
  setLoading = null,
  callback,
}) => {
  var config = {
    method: "delete",
    url:
      baseUrl +
      "/api/business/" +
      businessId +
      "/stationary-combustion/" +
      objectId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      if (use_swal)
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      if (loading) setLoading("success");
      if (callback) callback();
    })
    .catch(function (error) {
      console.log(error);
      if (loading) setLoading("failed");
      if (use_swal)
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
    });
};

export const getStationaryList = ({
  businessId,
  subcategory,
  subcategory_description,
  subcategoryId,
  objectId,
  objects,
  setObjects = function () {
    return;
  },
  setTotalObj = function () {
    return;
  },
  setSystemBoundaryCombustion = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/" + businessId + "/stationary-combustion",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setTotalObj(response.data.total_obj);
      setSystemBoundaryCombustion(
        response.data.total_obj.systemboundary_category
      );
      setObjects(
        response.data.data
          .filter(
            (data) =>
              data.subcategory === subcategory &&
              data.subcategory_description === subcategory_description &&
              (subcategoryId === null || data.subcategory_obj === subcategoryId)
          )
          .map((data) => {
            data.fuel_type = objectifyForDropdown(data.fuel_type);
            data.fuel_comply = data.fuel_comply ? "Yes" : "No";
            // Handle proper allocation based on leased fuel proportion
            if (
              data.leased_fuel_proportion &&
              data.leased_fuel_proportion > 0
            ) {
              // Get the total original carbon (before any allocation)
              const totalOriginalCarbon = data.carbon || 0;
              const leasedProportion = data.leased_fuel_proportion / 100;

              // Calculate proper allocation
              data.carbon_scope_1 =
                totalOriginalCarbon * (1 - leasedProportion);
              data.carbon_scope_3 = totalOriginalCarbon * leasedProportion;

              // Display Scope 1 emissions in the main carbon column
              data.carbon = data.carbon_scope_1;
            } else {
              // No leased proportion - all emissions go to Scope 1
              data.carbon_scope_1 = data.carbon || 0;
              data.carbon_scope_3 = 0;
            }
            return data;
          })
      );
    })
    .catch(function (error) {
      console.log(error);
      // setLoading(false)
      // Swal.fire({
      //   title: errorTranslate(),
      //   icon: 'error',
      //   text: error,
      //   confirmButtonColor: '#a9c1b4',
      //   // width: 600,
      //   // padding: '3em',
      //   color: '#476355',
      //   background: '#f1f8ef',
      // })
    });
};

export const updateStationary = ({
  businessId,
  objectId,
  subcategoryId,
  biomass_fuel_proportion,
  fuel_comply,
  leased_fuel_proportion,
  fuel_type,
  fuel_amount,
  invoice_date,
  invoice_number,
  price_invoice,
  subcategory,
  subcategory_description,
  manuel,
  objects,
  setObjects = function () {
    return;
  },
  loading = null,
  setLoading = null,
  use_swal = false,
  callback = null,
  setErrorMessage = function () {
    return;
  },
}) => {
  var data = JSON.stringify({
    subcategory_obj: subcategoryId,
    biomass_fuel_proportion: biomass_fuel_proportion || null,
    fuel_comply: fuel_comply,
    leased_fuel_proportion: leased_fuel_proportion || null,
    fuel_type: fuel_type,
    fuel_amount: fuel_amount,
    invoice_date: invoice_date || null,
    invoice_number: invoice_number || null,
    price_invoice: price_invoice || null,
    subcategory: subcategory,
    subcategory_description: subcategory_description,
    manuel: manuel || null,
  });

  var config = {
    method: "put",
    url:
      baseUrl +
      "/api/business/" +
      businessId +
      "/stationary-combustion/" +
      objectId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      setObjects(
        objects.map((supply) => {
          if (response.data.data.id === supply.id) {
            response.data.data.fuel_type = objectifyForDropdown(
              response.data.data.fuel_type
            );
            response.data.data.fuel_comply = response.data.data.fuel_comply
              ? "Yes"
              : "No";
            return response.data.data;
          }
          return supply;
        })
      );
      if (use_swal)
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      if (loading) setLoading("success");
      if (callback) callback();
    })
    .catch(function (error) {
      console.log(error);
      if (loading) setLoading("failed");

      if (use_swal)
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: defaultUpdateErrorMessage,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      setErrorMessage(error.response.data);
    });
};

export const getStationary = ({
  businessId,
  objectId,
  objects,
  setObjects,
  subcategory,
  subcategory_description,
  subcategoryId = null,
}) => {
  var config = {
    method: "get",
    url:
      baseUrl +
      "/api/business/" +
      businessId +
      "/stationary-combustion/" +
      objectId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(
        objects
          .filter(
            (data) =>
              data.subcategory === subcategory &&
              data.subcategory_description === subcategory_description &&
              (subcategoryId === null || data.subcategory_obj === subcategoryId)
          )
          .map((supply) => {
            const gotValue = response.data.data;

            if (gotValue.id === supply.id) {
              gotValue.fuel_type = objectifyForDropdown(gotValue.fuel_type);
              gotValue.fuel_comply = gotValue.fuel_comply ? "Yes" : "No";
              return gotValue;
            }
            return supply;
          })
      );
    })
    .catch(function (error) {
      console.log(error);
      // setLoading(false)
      // Swal.fire({
      //   title: errorTranslate(),
      //   icon: 'error',
      //   text: error,
      //   confirmButtonColor: '#a9c1b4',
      //   // width: 600,
      //   // padding: '3em',
      //   color: '#476355',
      //   background: '#f1f8ef',
      // })
    });
};
